import { addDays, format, subDays } from "date-fns";
import type { StatusJournalEntry } from "../StatusChart";

/**
 * One entry per day over the lookback window, zeroed for days the journal has no row for.
 *
 * Entries with a null date are keyed `"null"` by the callers' reduce and so never match a day
 * key — `ImportStatusList` relies on that to show its "no report date" warning instead.
 */
const buildStats = (daysAgo: number, journalByDate: Record<string, StatusJournalEntry> = {}): StatusJournalEntry[] => {
  const startDate = subDays(new Date(), daysAgo);
  return Array(daysAgo + 1)
    .fill(0)
    .map((_x, i) => {
      const currentDate = addDays(new Date(startDate), i);
      const currentDateKey = format(currentDate, "yyyy-MM-dd");
      if (currentDateKey in journalByDate) {
        return journalByDate[currentDateKey];
      } else {
        return {
          date: currentDateKey,
          completed: 0,
          dirty_rows: false,
          failed: 0,
          total_bytes: 0,
          total_rows: 0,
          max_bytes: 0,
          max_rows: 0,
          min_bytes: 0,
          min_rows: 0,
          running: 0,
        };
      }
    });
};

export { buildStats };
